import { DetectorType } from "../../utils/enum";
import { clearLog, log } from "../../utils/log";
import { IS } from "../../utils/util";
import { Detector } from "../detector";

export default class extends Detector {

  count: number = 0;
  func: Function = () => {};

  constructor() {
    super({
      type: DetectorType.FuncToString,
      enabled: (!IS.iosChrome && !IS.iosEdge),
    });
  }

  init() {
    this.count = 0;
    this.func = () => {};

    this.func.toString = () => {
      this.count ++;
      return '';
    };
  }

  detect() {
    this.count = 0;
    log(this.func);
    clearLog();
    if (this.count >= 2) {
      this.onDevToolOpen();
    }
  }
}